export const NO_TRANSLATE_CLASSNAME = 'notranslate';
